var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board_wrap"},[_c('div',{staticClass:"board_title"},[_c('h1',[_vm._v("홈페이지 제작")])]),_c('div',{staticClass:"product"})])
}]

export { render, staticRenderFns }